import { auth } from "./firebase";

// Sign Up
export const doCreateUserWithEmailAndPassword = (
  email: string,
  password: string
) => auth.createUserWithEmailAndPassword(email, password);

// Sign In
export const doSignInWithEmailAndPassword = (email: string, password: string) =>
  auth.signInWithEmailAndPassword(email, password);

// Sign out
export const doSignOut = () => auth.signOut();

// Password Reset
export const doPasswordReset = (email: string) =>
  auth.sendPasswordResetEmail(email);

// Password Change
export const doPasswordUpdate = async (password: string) => {
  if (auth.currentUser) {
    await auth.currentUser.updatePassword(password);
  }
  throw Error("No auth.currentUser!");
};


// // *** Auth API ***

// doCreateUserWithEmailAndPassword = (email, password) =>
//   this.auth.createUserWithEmailAndPassword(email, password);

// doSignInWithEmailAndPassword = (email, password) =>
//   this.auth.signInWithEmailAndPassword(email, password);

// doSignOut = () => this.auth.signOut();

// doPasswordReset = email => this.auth.sendPasswordResetEmail(email);

// doPasswordUpdate = password =>
//   this.auth.currentUser.updatePassword(password);

// // *** User API ***

// user = uid => this.db.ref(`users/${uid}`);

// users = () => this.db.ref('users');

// // *** User API ***

// project = id => this.db.ref(`projects/${id}`);

// projects = () => this.db.ref('projects');
// }

// export default Firebase;
